// Lib
import { defaultProps } from '../../../../../node_module_clones/recompose';

// Components
import PointerContainer from './PointerContainer';

export default defaultProps({ color: '#666666' })(PointerContainer);
